<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<!-- 서브메뉴 탭 구성 //-->
<ng-container *ngIf="(currMenu$ | async)['page_cd'].length > 6 && (currMenu$ | async)['parentNode']['children'].length > 0">
  <ul class="sub-tab inner-wrap">
    <li class="nav-item" *ngFor="let item of (currMenu$ | async)['parentNode']['children']; index as i">
      <a class="cp nav-link" [ngClass]="{active: (currMenu$ | async)['seq'] == item.seq}"  (click)="goLink(item)">{{item.page_menu_name}}</a>
    </li>
  </ul>
</ng-container>

<div id="board">
  <div class="inner-wrap">
    <!--  검섹조건 : 회원사소식 -->
    <div class="search-condition" *ngIf="params.board_id !== 'ecatalogs' && params.type=='list'">
      <div class="search-input">
        <div class="select" [ngClass]="{on: isSelectOnA}" (click)="isSelectOnA=!isSelectOnA" (mouseleave)="isSelectOnA=false">
          <div class="selected-item">{{isSelectTxtA}}</div>
          <ul class="select-item">
            <li (click)="selectSearchGroup('')">전체</li>
            <li (click)="selectSearchGroup('subject')">제목</li>
            <li (click)="selectSearchGroup('contents')">내용</li>
            <li (click)="selectSearchGroup('writer')">등록자</li>
          </ul>
        </div>

        <input type="text" [(ngModel)]="params.searchText" class="input-txt" (keypress)="searchList($event)" />
        <button type="button" class="search-btn" (click)="getBoardList()">검색</button>
        <button type="button" class="reset-btn" (click)="initSearch()">초기화</button>
      </div>
    </div>

    <!-- 검섹조건 : e카달로그 -->
    <div class="search-condition1" *ngIf="params.board_id == 'ecatalogs' && params.type=='list'">
      <div class="search-input">
        <div class="search">
          <div class="select select1" [ngClass]="{on: isSelectOnB1}" (click)="isSelectOnB1=!isSelectOnB1" (mouseleave)="isSelectOnB1=false">
            <div class="selected-item cp">{{isSelectTxtB1}}</div>
            <ul class="select-item">
              <li class="cp" (click)="initCategory1()">1차 선택하세요.</li>
              <li class="cp" *ngFor="let item of category; let i = index" (click)="selectCategory1( item, i )">{{item.directory_name}}</li>
            </ul>
          </div>
          <div class="select select2" [ngClass]="{on: isSelectOnB2}" (click)="isSelectOnB2=!isSelectOnB2" (mouseleave)="isSelectOnB2=false">
            <div class="selected-item cp">{{isSelectTxtB2}}</div>
            <ul class="select-item">
              <li class="cp" (click)="initCategory2()">2차 선택하세요.</li>
              <ng-container *ngIf="params.category1_index > -1">
              <li class="cp" *ngFor="let item of category[params.category1_index]['children'];let i = index" (click)="selectCategory2( item, i )">{{item.directory_name}}</li>
              </ng-container>
            </ul>
          </div>
          <div class="select" [ngClass]="{on: isSelectOnB}" (click)="isSelectOnB=!isSelectOnB" (mouseleave)="isSelectOnB=false">
            <div class="selected-item">{{isSelectTxtB}}</div>
            <ul class="select-item">
              <li (click)="selectCategory3('subject')">제품명</li>
              <li (click)="selectCategory3('company')">회사명</li>
            </ul>
          </div>
          <input type="text" [(ngModel)]="params.searchText" (keypress)="searchList($event)" class="input-txt" />
        </div>
        <div class="btn-area">
          <button type="button" class="search-btn" (click)="getBoardList()">검색</button>
          <button type="button" class="reset-btn" (click)="initSearchECatalogs()">초기화</button>
        </div>
        <div class="cb"></div>
      </div>
    </div>

    <app-board-list *ngIf="params.type=='list'" [boardInfo]="boardInfo" [memberInfo]="memberInfo" [data]="data" [params]="params" [totalCount]="totalCount" [authCheck$]="authCheck$"></app-board-list>
    <app-board-write *ngIf="params.type=='write' || params.type=='modify'"></app-board-write>
    <app-board-reply *ngIf="params.type=='reply'"></app-board-reply>

  </div>
</div>

<app-footer></app-footer>
